import { render, staticRenderFns } from "./home.module.vue?vue&type=template&id=03bf0992"
import script from "./home.module.vue?vue&type=script&lang=js"
export * from "./home.module.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports